import AMobileDataForm from "./aMobileDataForm";
import LocalBookingStorageAccess from "../../../services/database/localBookingStorageAccess";
import {dataToServerTable} from "../../../config.json";

class MobileLocalBookingStorageDataForm extends AMobileDataForm {
    record = {};

    tableName = "local booking";
    tableDefinition = {
        0: {
            // id: 0,
            name: "id",
            value: "",
            label: "Id",
            disabled: true
        },
        1: {
            // id: 1,
            name: "dateCreated",
            value: "",
            label: "dateCreated",
            disabled: true
        },
        2: {
            // id: 2,
            name: "lastUpdated",
            value: "",
            label: "lastUpdated",
            disabled: true
        },
        3: {
            // id: 3,
            name: "url",
            value: "",
            label: "URL",
            disabled: true
        },
        4: {
            // id: 4,
            name: "table",
            value: "",
            label: "Table",
            disabled: true
        }
    };

    loadData = async () => {
        const {tableDefinition} = this;
        const {database, id} = this.props;
        let dataTableList = [];
        const data = {};

        if (database) {
            this.record = await LocalBookingStorageAccess.getById(
                database,
                dataToServerTable,
                id
            );
            if (this.record) {
                const recordData = JSON.parse(this.record.recordData);

                let item = {...tableDefinition[0]};
                // item["value"] = this.record.id;
                data["id"] = this.record.id;
                dataTableList.push(item);

                item = {...tableDefinition[1]};
                // item["value"] = this.record.dateCreated;
                data["dateCreated"] = this.record.dateCreated;
                dataTableList.push(item);

                item = {...tableDefinition[2]};
                // item["value"] = this.record.lastUpdated;
                data["lastUpdated"] = this.record.lastUpdated;
                dataTableList.push(item);

                item = {...tableDefinition[3]};
                // item["value"] = this.record.url;
                data["url"] = this.record.url;
                dataTableList.push(item);

                item = {...tableDefinition[4]};
                // item["value"] = recordData.table;
                data["table"] = recordData.table;
                dataTableList.push(item);

                // let idCounter = 5;
                for (const [key, value] of Object.entries(recordData.fields)) {
                    const item = {
                        // id: idCounter++,
                        name: key,
                        // value: value,
                        label: key,
                        disabled: true
                    };
                    data[key] = value;
                    dataTableList.push(item);
                }
            }
        }
        this.setState({dataTableList, data});
    };
}

export default MobileLocalBookingStorageDataForm;
